module.exports = __webpack_public_path__ + "img/transform.a7b90a97.png";